import { UseQueryResult } from "@tanstack/react-query";

export function useOptions(query: UseQueryResult<string[]>) {
  return query.isLoading || !query.data ? [] : query.data.map((x: any) => ({ label: x, value: x }));
}
